import React from "react";
import { Skeleton, Stack, Box } from "@mui/material";

const MaintenanceItemEmptyComponent = ({ rows = 5 }) => {
    return (
        <Box mt={1}>
            <Stack spacing={1}>
                {Array.from({ length: rows }).map((_, index) => (
                    <Skeleton key={index} className="skeleton-pulse" width={"100%"} height={35} />
                ))}
            </Stack>
        </Box>
    );
};

export const MaintenanceItemEmpty = React.memo(MaintenanceItemEmptyComponent);
MaintenanceItemEmpty.displayName = "MaintenanceItemEmpty";
